import { CategoryService } from "./category.service";
import { ProductService } from "./product.service";

export default {
  CategoryService,
  ProductService,
};

export const SERVICES = [CategoryService, ProductService];
